import { makeStyles } from "@mui/styles";
import { BaseThemeOptions } from "themes/base";

export const useStyles = makeStyles(() => ({
	tableTopbar: {
		height: "100%",
	},
}));
